export default __webpack_public_path__ + "static/media/pen-generic-prize.e1c0b25e.png";